import type {
  Account,
  Event as UserEvent,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { DeepReadonlyObject } from "rxdb"
import { useFindUserEvents } from "./useFindUserEvents"
import { createEventQueryObject } from "src/utils"

export function useOldestUserEvent(accountId: Account["id"]):
| DeepReadonlyObject<UserEvent>
| undefined {
  const queryObject = useMemo(
    () => createEventQueryObject(
      accountId,
      {
        sort: [{ started_at: "asc" as const }],
        limit: 1,
      },
    ),
    [accountId],
  )

  const { result } = useFindUserEvents(queryObject)
  return result[0]
}
